<template>
  <div class="dropdown icon-dropdown" v-bind:class="classBindings">
    <button class="btn btn-outline-secondary btn-icon rounded-circle menu-toggle" v-on:click="toggleMenu">
      <i class="material-icons" v-if="horizontal">
        more_horiz
      </i>
      <i class="material-icons" v-else>
        more_vert
      </i>
    </button>
    <div class="dropdown-menu dropdown-menu-right">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import clickout from '../mixins/clickout';

  export default {
    name: 'icon-dropdown',

    mixins: [
      clickout,
    ],

    props: {
      dropup: {
        type: Boolean,
        default: false,
      },
      horizontal: {
        type: Boolean,
        default: true,
      },
    },

    data() {
      return {
        visible: false,
      };
    },

    computed: {
      classBindings() {
        return {
          show: this.visible,
          dropup: this.dropup,
        };
      },
    },

    watch: {
      visible(state, old) {
        if (state === old) {
          // Avoid duplicated emits
          return;
        }

        if (state) {
          this.$root.$emit('shown::dropdown', this);
        } else {
          this.$root.$emit('hidden::dropdown', this);
        }
      },
    },

    methods: {
      toggleMenu() {
        this.visible = !this.visible;
      },

      clickOutListener() {
        this.visible = false;
      },

      click() {
        this.toggleMenu();
      },
    },

    created() {
      this.$root.$on('shown::dropdown', (el) => {
        if (el !== this) {
          this.visible = false;
        }
      });
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/IconDropdown.vue